import { AssemblyJourneys } from 'src/constants/assemblyJourneys';
import { IComponent } from 'src/interfaces';
import { IAssemblyComponent } from 'src/interfaces/Assembly';
import { GcfMockData } from 'src/utils/gcf-helper';

export enum DurationUpdateTypes {
  MAIN = 'main',
  BACKUP = 'backup',
  BOTH = 'both',
}

export interface ComponentInfoProps {
  assemblyComponent: IAssemblyComponent;
  onUpdateRotationDuration: (
    uid: string,
    duration: number,
    type?: DurationUpdateTypes,
  ) => void;
  onReplacedComponent: () => void;
  onDeletedAssemblyComponent: () => void;
  onReorderRotation: (
    assemblyComponent: IAssemblyComponent,
    direction: 'up' | 'down',
  ) => void;
  availableRotations: number;
  componentIndex: number;
  onSelectBackupComponent: (
    component: IComponent,
    rotation_order: number,
    duration?: number,
  ) => void;
  backupAssemblyComponent: IAssemblyComponent[];
  editable?: boolean;
  isCodConfirmationOpen?: boolean;
  onDeletedBackupAssemblyComponent: (
    assemblyComponent: IAssemblyComponent,
  ) => void;
  parentBackupAssemblyComponents: IAssemblyComponent[];
  activeAssemblyJourney?: AssemblyJourneys;
  customerState: Partial<GcfMockData>;
  assemblyId?: number;
  showOwnerOperatorPermissions: boolean;
  replaceCurrentComponentText?: string;
  showSoftSellInfo: boolean;
  removeComponentTitleText?: string;
  handleUpdateBackupAssemblyComponents?: (value: IAssemblyComponent[]) => void;
  productFilters?: string[];
  productVariationFilters?: string[];
  skipProductsApiOnEmptyFilters?: boolean;
}
